import { Injectable } from '@angular/core';
import {
    BulkUpdateReleaseItemsRequest,
  ListReleasesRequest,  ListReleasesResponse, Release, ReleaseItemFieldToUpdate, ReleaseStatus, SituViewWebApiClient
} from 'situview-webapi-client';


@Injectable({
  providedIn: 'root'
})
export class ReleaseService {
  private releases: any[] | null = null;
  private lastFetchReleaseCompanyId: string | null = null;
  private lastFetchTime: Date | null = null;
  private cacheDuration = 5 * 60 * 1000; // 5 minutes in milliseconds

  constructor(
    private situViewClient: SituViewWebApiClient
  )  {}

  public getStatusColor(status: ReleaseStatus, isDarkMode: boolean): string {
    switch (status) {
      case ReleaseStatus.Proposed:
          return isDarkMode ? '#89CFF0' : '#1E90FF'; // Baby Blue / Dodger Blue
      case ReleaseStatus.ReadyForRender:
          return isDarkMode ? '#A4DDED' : '#00BFFF'; // Light Sky Blue / Deep Sky Blue
      case ReleaseStatus.RenderFailed:
          return isDarkMode ? '#B39EB5' : '#9370DB'; // Pastel Purple / Medium Purple
      case ReleaseStatus.ReadyForReview:
          return isDarkMode ? '#FFD1DC' : '#FF69B4'; // Pastel Pink / Hot Pink
      case ReleaseStatus.RequiresAttentionSitu:
          return isDarkMode ? '#FFB347' : '#FF8C00'; // Pastel Orange / Dark Orange
      case ReleaseStatus.RequiresAttentionVendor:
          return isDarkMode ? '#FDFD96' : '#FFD700'; // Pastel Yellow / Gold
      case ReleaseStatus.StandardReviewed:
      case ReleaseStatus.ApprovedForLive:
          return isDarkMode ? '#77DD77' : '#32CD32'; // Pastel Green / Lime Green
      case ReleaseStatus.ReadyForLive:
          return isDarkMode ? '#C1E1DC' : '#3CB371'; // Mint Cream / Medium Sea Green
      case ReleaseStatus.Live:
          return isDarkMode ? '#FFB6C1' : '#FF1493'; // Light Pink / Deep Pink
      case ReleaseStatus.RenderingStandard:
          return isDarkMode ? '#B4CFB0' : '#8FBC8F'; // Light Sage Green / Dark Sea Green
      case ReleaseStatus.RenderingHiRes:
          return isDarkMode ? '#FAD2E1' : '#FF69B4'; // Light Rose Pink / Hot Pink
      case ReleaseStatus.OnHold:
          return isDarkMode ? '#A9A9A9' : '#D3D3D3'; // Dark Gray / Light Gray
      default:
          return "";
    }
  }

  public SetStatusReleaseItems(companyId: string, releaseItemIds: string[], releaseStatus: ReleaseStatus) {
    let request = new BulkUpdateReleaseItemsRequest();
    request.releaseItemIds = releaseItemIds;
    request.companyId = companyId;
    request.releaseItemFieldToUpdate = ReleaseItemFieldToUpdate.ReleaseStatus;
    request.releaseStatus = releaseStatus;

    return this.situViewClient.bulkUpdateReleaseItems(request);
  }

  loadReleases(companyId: string): Promise<Release[] | undefined> {
    // Check if cached data is still valid
    if (this.releases && this.lastFetchTime && this.lastFetchReleaseCompanyId) {
      const now = new Date();
      if (now.getTime() - this.lastFetchTime.getTime() < this.cacheDuration &&
      this.lastFetchReleaseCompanyId === companyId) {
        // Return cached data if within valid time frame
        return Promise.resolve(this.releases);
      }
    }
  
    // If no valid cache, fetch new data
    //this.loading = true;
  
    let request = new ListReleasesRequest();
    request.companyId = companyId;
  
    return this.situViewClient.listReleases(request)
      .then((response: ListReleasesResponse) => {
        if (response.success) {
          this.releases = response.items ?? [];
          this.lastFetchReleaseCompanyId === companyId;
          this.lastFetchTime = new Date(); // Update last fetch time
          return this.releases; // Ensure to return the releases
        } else {
          //this.showMessage("There was an issue retrieving releases!");
          return undefined; // Return undefined in case of failure
        }
      })
      .catch((err: any) => {
       //this.showMessage("Could not retrieve releases!");
        return undefined; // Return undefined in case of error
      })
      .finally(() => {
        //this.loading = false;
      });
  }
}